var map = {
	"./082---EliteSideKick.json": 73075,
	"./083---Shielder.json": 26640,
	"./084---Spawner.json": 2824,
	"./085---Spawnling.json": 47494,
	"./086---Fogger.json": 89308,
	"./087---Defender.json": 15040,
	"./088---Necromant.json": 69071,
	"./089---BonePillar.json": 66223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92389;